import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyRecipientDraftCardView = loadable(
  () => import(/* webpackChunkName: "content/card/recipientdraftcardview" */ './RecipientDraftCardView'),
  'RecipientDraftCardView',
);
